<script type="module">
import * as THREE from 'three';
import { LineMaterial } from 'three/examples/jsm/lines/LineMaterial.js';
import { LineSegments2 } from 'three/examples/jsm/lines/LineSegments2.js';
import { LineSegmentsGeometry } from 'three/examples/jsm/lines/LineSegmentsGeometry.js';

export default class MySkeletonHelper extends LineSegments2 {
	// constructor(object, color1=null, color2=null, filter=null) {
	constructor(object, color1=null, color2=null) {
		// var bones = getBoneList(object, filter);
		var bones = getBoneList(object);
		var geometry = new LineSegmentsGeometry();
		if (color1 === null) {
			color1 = new THREE.Color(0x46BBA7);
		}
		if (color2 === null) {
			color2 = new THREE.Color(0x705CD3);
		}

		var vertices = [];
		var colors = [];
		var matrix_world_inverse = new THREE.Matrix4();

		matrix_world_inverse.copy(object.matrixWorld).invert();

		for (var i = 0; i < bones.length; i++) {
			var bone = bones[i];

			// First bone is the root and doesn't need a line.
			// Each bone has a start point (its parent) and an end point.
			if (bone.parent && bone.parent.isBone) {
				vertices.push(0, 0, 0);
				vertices.push(0, 0, 0);
				colors.push(color1.r, color1.g, color1.b);
				colors.push(color2.r, color2.g, color2.b);
			}
		}

		geometry.setPositions(vertices);
		geometry.setColors(colors);

		let material = new LineMaterial({
			color: 0xffffff,
			linewidth: 0.0075, // in pixels
			vertexColors: true,
			dashed: true,
			depthTest: false,
			depthWrite: false,
		});

		super(geometry, material);
		this.type = 'MySkeletonHelper';
		this.MySkeletonHelper = true;

		this.root = object;
		this.bones = bones;

		this.matrix = object.matrixWorld;
		this.matrixAutoUpdate = false;
	}

	updateMatrixWorld(force) {
		var position = this.geometry.getAttribute('position');

		var vertices = [];
		var vector = new THREE.Vector3();
		var bone_matrix = new THREE.Matrix4();
		var matrix_world_inverse = new THREE.Matrix4();

		matrix_world_inverse.copy(this.root.matrixWorld).invert();

		for (let i = 0; i < this.bones.length; i++) {
			var bone = this.bones[i];

			if (bone.parent && bone.parent.isBone) {
				bone_matrix.multiplyMatrices(matrix_world_inverse, bone.matrixWorld);
				vector.setFromMatrixPosition(bone_matrix);
				vertices.push(vector.x, vector.y, vector.z);

				bone_matrix.multiplyMatrices(matrix_world_inverse, bone.parent.matrixWorld);
				vector.setFromMatrixPosition(bone_matrix);
				vertices.push(vector.x, vector.y, vector.z);
			}
		}

		this.geometry.setPositions(vertices);

		position.needsUpdate = true;
		super.updateMatrixWorld(force);
	}
}


function getBoneList(object) {
	const boneList = [];
	// console.log(filter)
	if (object.isBone === true) {
		// console.log(object)
		boneList.push(object);
	}

	for (let i = 0; i < object.children.length; i++) {
		boneList.push.apply(boneList, getBoneList(object.children[i]));
	}

	return boneList;

}


</script>
